module.exports = __webpack_public_path__ + "img/1450190023.69c55916.jpg";